import { CancelFunctions } from 'components/common/types';
import { cancelFunctions } from 'utils/cancelFunctions';
import { ComponentType } from 'react';

interface WithCancelRequestProps extends Object {
  cancelFunctions?: CancelFunctions;
}

const withCancelRequest = <P extends WithCancelRequestProps>(WrappedComponent: ComponentType<Partial<P>>) => {
  return (props: Partial<P>) => {
    // eslint-disable-next-line react/jsx-props-no-spreading
    return <WrappedComponent cancelFunctions={cancelFunctions} {...props} />;
  };
};

export default withCancelRequest;
